import React from 'react'

export default function MainUnAuth() {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%",fontSize: "1.5em" }}>
        SignIn/Register to interact with the Posts or try out the new Feature GHOST Mode to view the posts
    </div>
  )
}
